import mydecodedTokenFunction from "./DecodedToken";

export default function useDecodedToken() {
    const token = localStorage.getItem('token')
    const decodedToken = mydecodedTokenFunction(token);
    return decodedToken;
}